import {AfterViewInit, Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[scrollHeader]'
})
export class ScrollHeaderDirective implements AfterViewInit {
  breakpoint = 70;
  triggerTimeout: number;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    if (typeof window === 'undefined') return;

    const el = <HTMLElement>this.el.nativeElement;
    const elChild = <HTMLElement>el.firstElementChild;

    window.addEventListener('scroll', () => {
      window.clearTimeout(this.triggerTimeout);
      if (window.pageYOffset > this.breakpoint) {
        el.style.height = `${elChild.offsetHeight}px`;
        this.triggerTimeout = window.setTimeout(() => {
          if (el.offsetHeight > 39) el.style.overflow = 'visible';
        }, 500);
      }
      if (window.pageYOffset < this.breakpoint) {
        el.style.overflow = 'hidden';
        el.style.height = '0px';
        return;
      }
    });
  }
}
